
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import PdfViewerDialog from "@/components/general/PdfViewerDialog.vue";
import PosManagerReportElement from "@/components/PosManagerReportElement.vue";

@Component({
    components: {PosManagerReportElement, PdfViewerDialog},
})
export default class ProductsStart extends Vue {
    private loading = false;
    private activeTab = 0;
    private tabs: any[] = [];
    private smallTabs: boolean = this.$vuetify.breakpoint.smAndDown;
    @Prop({default: false})
    private isTransmitting!: boolean;
    @Prop({default: 1})
    private connectionState!: number;
    async mounted() {
        this.tabs = [
            {
                id: 0,
                route: `/artikel/0`,
                name: 'Sortiment',
                icon: 'posmanager-item',
                gridName: 'BROWSE_ABTEILUNGEN',
                formName: '',
                context:""
            },
            {
            id: 1,
            route: `/artikel/1`,
            name: 'Listen',
            icon: 'ordermanager-report-print-2',
            gridName: 'BROWSE_BESTAENDE',
            formName: '',
            context:""
        }]
    }

    @Watch('activeTab')
    private activeTabChanged() {
        const element = document.getElementById("app");
        if (!element) {
            return;
        }
        window.scrollTo(0, element.offsetTop);
    }

    private isDisabled():boolean {

        // const configResult = this.$ports.auth.getUserConfig(false);
        // if (tab.id === 0) {
        //     configResult.then(res => {
        //         return res.permissions.COMMON.REPORTS === 0;
        //     });
        //
        // }
        return false;
    }
}
